import { Link } from 'react-router-dom';
import './simple-intro.scss';

const interests = ['AI Theory', 'Generative Modeling', 'Information Theory'];

export default function SimpleIntro() {
  return (
    <main className="simple-intro" id="intro">
      <div className="simple-intro-content">
        <div className="simple-intro-bio">
          <p className="simple-intro-eyebrow">RESEARCHER & WRITER</p>
          <h1>Yindong Wang <span lang="zh">王殷冬</span></h1>
          <p className="simple-intro-role">PhD student at Hasso Plattner Institute</p>
          <p className="simple-intro-description">
            I study the foundations of AI, with interests in generative modeling, information theory, and the underlying mathematical structures that govern these generative processes and the assumptions that are often taken for granted.
          </p>
          <p className="simple-intro-description">
            Outside research, I’m an amateur <Link to="/blog">writer</Link>,
            writing everything else except papers.
          </p>
          <p className="simple-intro-email">For contact: <a href="mailto:hi@yindong.me">hi@yindong.me</a></p>
        </div>
        <div className="simple-intro-portrait-wrap">
          <div className="simple-intro-portrait-card">
            <img className="simple-intro-portrait" src="/image_me.jpg" alt="Yindong Wang" />
            <div className="simple-intro-portrait-caption">
              <span className="simple-intro-portrait-caption-item">
                📅 Mar 2026
              </span>
              <span className="simple-intro-portrait-caption-item">
                📍 Laoyuhe Wetland Park, Kunming 🇨🇳
              </span>
              <span className="simple-intro-portrait-caption-item">
                📷 Hanh
              </span>
            </div>
          </div>
        </div>
        <section className="simple-intro-interests" aria-labelledby="home-interests">
          <h2 id="home-interests">Research interests</h2>
          <ul>{interests.map(interest => <li key={interest}>{interest}</li>)}</ul>
        </section>
      </div>
    </main>
  );
}
